import { browserApi } from 'lib/httpClient';
import { SearchCollection } from 'searchCollection';

async function getCollection(): Promise<SearchCollection> {
  try {
    const { data } = await browserApi.get<SearchCollection>('/search/collection');
    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao buscar coleções pelo browserApi:', error);
    return { matrices: [] };
  }
}
export default getCollection;
